module.exports = __webpack_public_path__ + "img/12.2c60944a.png";